import * as actionTypes from '../actions/artefacts';
import { addItemInListOfItems, updateItemInListOfItems, deleteItemByIdInListOfItems } from '../../helpers';

const initialState = {
    artefacts: [],
    
    getArtefactsLoading: false,
    getArtefactsError: null,

    addArtefactLoading: false,
    addArtefactError: null,

    deleteArtefactLoading: false,
    deleteArtefactError: null,

    updateArtefactLoading: false,
    updateArtefactError: null,

    artefactTypes: [],
    
    getArtefactTypesLoading: false,
    getArtefactTypesError: null,
};

const artefactsReducer = (state = initialState, action) => {
    switch(action.type) {
        // GET ARTEFACTS
        case actionTypes.GET_ARTEFACTS_REQUEST:
            return {
                ...state,
                getArtefactsLoading: action.loading,
            };
        case actionTypes.GET_ARTEFACTS_SUCCESS:
            return {
                ...state,
                getArtefactsLoading: action.loading,
                getArtefactsError: null,
                artefacts: action.artefacts,
            };
        case actionTypes.GET_ARTEFACTS_ERROR:
            return {
                ...state,
                getArtefactsLoading: action.loading,
                getArtefactsError: action.error,
            };

        // ADD ARTEFACT
        case actionTypes.ADD_ARTEFACT_REQUEST:
            return {
                ...state,
                addArtefactLoading: action.loading,
            };
        case actionTypes.ADD_ARTEFACT_SUCCESS:
            return {
                ...state,
                addArtefactLoading: action.loading,
                addArtefactError: null,
                artefacts: addItemInListOfItems(state.artefacts, action.artefact),
            };
        case actionTypes.ADD_ARTEFACT_ERROR:
            return {
                ...state,
                addArtefactLoading: action.loading,
                addArtefactError: action.error,
            };
        
        // DELETE ARTEFACT
        case actionTypes.DELETE_ARTEFACT_REQUEST:
            return {
                ...state,
                deleteArtefactLoading: action.loading,
            };
        case actionTypes.DELETE_ARTEFACT_SUCCESS:
            return {
                ...state,
                deleteArtefactLoading: action.loading,
                deleteArtefactError: null,
                artefacts: deleteItemByIdInListOfItems(state.artefacts, action.artefactId),
            };
        case actionTypes.DELETE_ARTEFACT_ERROR:
            return {
                ...state,
                deleteArtefactLoading: action.loading,
                deleteArtefactError: action.error,
            };
        
        // UPDATE ARTEFACT
        case actionTypes.UPDATE_ARTEFACT_REQUEST:
            return {
                ...state,
                updateArtefactLoading: action.loading,
            };
        case actionTypes.UPDATE_ARTEFACT_SUCCESS:
            return {
                ...state,
                updateArtefactLoading: action.loading,
                updateArtefactError: null,
                artefacts: updateItemInListOfItems(state.artefacts, action.artefact),
            };
        case actionTypes.UPDATE_ARTEFACT_ERROR:
            return {
                ...state,
                updateArtefactLoading: action.loading,
                updateArtefactError: action.error,
            };

        // GET ARTEFACT TYPES
        case actionTypes.GET_ARTEFACTS_REQUEST:
            return {
                ...state,
                getArtefactTypesLoading: true,
            };
        case actionTypes.GET_ARTEFACT_TYPES_SUCCESS:
            return {
                ...state,
                getArtefactTypesLoading: false,
                getArtefactTypesError: null,
                artefactTypes: action.types,
            };
        case actionTypes.GET_ARTEFACTS_ERROR:
            return {
                ...state,
                getArtefactTypesLoading: false,
                getArtefactTypesError: action.error,
            };

        // DEFAULT
        default:
            return state;
    }
};

export default artefactsReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/artefacts.js